import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const ScrollBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  flex: 1 1 auto;
  overflow: auto;
  padding-left: ${size(3)};
  padding-right: ${size(3)};
  padding-bottom: ${size(3)};

  ${theme.screens.Md} {
    padding-left: ${size(5)};
    padding-right: ${size(5)};
    padding-bottom: ${size(5)};
  }

  &.no-padding {
    padding: 0;

    ${theme.screens.Md} {
      padding: 0;
    }
  }
`;

export const Foot = styled.div`
  flex: 0 0 auto;
  padding: ${size(2)} ${size(3)};
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  ${theme.screens.Md} {
    padding: ${size(2)} ${size(5)};
  }
`;

export const ScrollBoxImage = styled.div`
  padding: 0 ${size(5)};
  margin: 0 ${size(5)};
`;
